import {sweetAPI} from 'app/store/sweet-api';
import {showLoadingBar, showMessages} from 'app/store/sweet-api/utils';
import {ATTACHMENT_API_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: []})
  .injectEndpoints({
    endpoints: (build) => ({
      deleteAttachment: build.mutation<unknown, {key: string}>({
        query: ({key}) => ({
          url: `${ATTACHMENT_API_URL}${key}/`,
          method: 'DELETE',
        }),
        onQueryStarted: (args, api) => {
          showLoadingBar(args, api);
          showMessages({
            onError: () => gt('Unable to delete attachment.'),
          })(args, api);
        },
      }),
    }),
  });

export const {useDeleteAttachmentMutation: useDeleteAttachment} = extendedAPI;
